import dayjs from 'dayjs'
import { createRequest, handleErrorCatchLog } from '../../Helpers/GenericHelpers'
import store from '../../store'
import { DateFormat, RuleType, TimeFormat, priceGenerationSectionId } from '../../Constants/Configuration'
import { getTokenFromSessionStorage } from '../../Helpers/TokenHelper'
import { PriceTypeShow } from 'Constants/TableConfiguration'
import { PricetoSave, basePricelist } from 'Helpers/PricesHelper'

interface ArticlePriceList {
  name: string
  isSell: boolean
  prices: ArticlePrice[]
}

interface ArticlePrice {
  startDate: string
  endDate?: string
  isCurrent: boolean
  price: number
  sellPrice: number
  buyPrice: number
  discount: number
  type: RuleType
}

const getPriceData = async (rowKey: number): Promise<ArticlePriceList[]> => {
  var state = store.getState()
  const gridEnable: boolean =
    state.present.dynamicGrid.gridLayout.findIndex(gridElement => gridElement.i === priceGenerationSectionId) >= 0
  const token = getTokenFromSessionStorage()
  const filterDateRange = state.present.price.priceFilterDateRange
  const priceTypeShow = state.present.price.priceTypeShow
  const pricelistTypeFilter = state.present.configuration.pricelistTypeFilter

  if (
    !state.present.article.serverConfig ||
    !state.present.configuration.isOmnichannelAndPricesVisibile ||
    state.present.article.rowKeysSelected[0] !== rowKey ||
    !gridEnable ||
    !token
  )
    return [] as ArticlePriceList[]

  const isSuperCategoryEnabled = state.present.configuration.isSuperCategoryEnabled

  const dateFrom =
    priceTypeShow === PriceTypeShow.history && filterDateRange && filterDateRange.dateFrom
      ? new Date(filterDateRange.dateFrom).setHours(0, 0, 0) +
        new Date(filterDateRange.dateFrom).getTimezoneOffset() * -60000
      : dayjs().utc().valueOf()
  const dateTo =
    priceTypeShow === PriceTypeShow.history && filterDateRange && filterDateRange.dateTo
      ? new Date(filterDateRange.dateTo).setHours(23, 59, 0) +
        new Date(filterDateRange.dateTo).getTimezoneOffset() * -60000
      : dayjs().utc().valueOf()

  const body = {
    From: new Date(dateFrom),
    To: new Date(dateTo),
    ShowHistory: priceTypeShow === PriceTypeShow.history,
  }

  const response = await createRequest(
    `/api/price/${rowKey}/history/?config=${state.present.article.serverConfig}` +
      `&typeOfChannel=${state.present.price.channelType}` +
      `&isSuperCategoryEnabled=${isSuperCategoryEnabled}` +
      `&pricelistTypeFilter=${pricelistTypeFilter}`,
    'POST',
    body,
    token,
    true,
    true,
  )

  const articlePriceListCollection: ArticlePriceList[] = await response.json()
  articlePriceListCollection.forEach(articlePriceList => {
    articlePriceList.prices?.forEach(articlePrice => {
      if (articlePrice.startDate)
        articlePrice.startDate = dayjs(articlePrice.startDate).format(`${DateFormat} ${TimeFormat}`)
      if (articlePrice.endDate) articlePrice.endDate = dayjs(articlePrice.endDate).format(`${DateFormat} ${TimeFormat}`)
    })
  })

  return articlePriceListCollection
}

const getBasePriceList = async (rowKey: number): Promise<basePricelist[]> => {
  var state = store.getState()
  const gridEnable: boolean =
    state.present.dynamicGrid.gridLayout.findIndex(gridElement => gridElement.i === priceGenerationSectionId) >= 0
  const token = getTokenFromSessionStorage()
  const pricelistTypeFilter = state.present.configuration.pricelistTypeFilter
  if (
    !state.present.article.serverConfig ||
    !state.present.configuration.isOmnichannelAndPricesVisibile ||
    state.present.article.rowKeysSelected[0] !== rowKey ||
    !gridEnable ||
    !token
  )
    return [] as basePricelist[]

  const response = await createRequest(
    `/api/price/${rowKey}/basePrices/?config=${state.present.article.serverConfig}` +
      `&pricelistTypeFilter=${pricelistTypeFilter}`,
    'GET',
    undefined,
    token,
    true,
    true,
  )

  const articlePriceListCollection: basePricelist[] = await response.json()

  return articlePriceListCollection
}

const savePricesChanges = (rowKey: number, updateList: PricetoSave[]): any => {
  const state = store.getState()
  const gridEnable: boolean =
    state.present.dynamicGrid.gridLayout.findIndex(gridElement => gridElement.i === priceGenerationSectionId) >= 0
  const token = getTokenFromSessionStorage()
  const pricelistTypeFilter = state.present.configuration.pricelistTypeFilter
  if (
    !state.present.article.serverConfig ||
    !state.present.configuration.isOmnichannelAndPricesVisibile ||
    state.present.article.rowKeysSelected[0] !== rowKey ||
    !gridEnable ||
    !token
  ) {
    return new Promise(resolve => {})
  }

  const body = {
    pricesToSave: updateList,
  }

  return createRequest(
    `/api/price/${rowKey}/basePrices/?config=${state.present.article.serverConfig}` +
      `&pricelistTypeFilter=${pricelistTypeFilter}`,
    'POST',
    body,
    token,
  )
    .then(response => response.json())
    .then(data => {})
    .catch(err => {
      handleErrorCatchLog(err, 'Failed to save price  changes')
    })
}

export { getPriceData, savePricesChanges, getBasePriceList }
